export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" data-testid="logo-mark" aria-hidden="true">
    <rect x="20" y="20" width="60" height="16" fill="#00F0FF" />
    <rect x="42" y="36" width="16" height="44" fill="#00F0FF" />
    <path d="M80 20L64 36H80V20Z" fill="#FFFFFF" opacity="0.8" />
  </svg>
);

export const Logo = ({ onClick }) => (
  <a
    href="#top"
    data-testid="logo-link"
    aria-label="Tarbyte — back to top"
    onClick={(e) => {
      e.preventDefault();
      if (onClick) onClick();
      else if (window.__lenis) window.__lenis.scrollTo(0);
      else window.scrollTo({ top: 0, behavior: "smooth" });
    }}
    className="flex items-center gap-3 focus:outline-none focus:ring-2 focus:ring-[#00F0FF] rounded-full"
  >
    <LogoMark />
    <span className="font-display font-extrabold text-xl tracking-tight text-white">
      TAR<span className="text-[#00F0FF]">BYTE</span>
    </span>
  </a>
);
